// TODO drop when all actions are reexported statically

const exports = {};
var req = require.context('.', true, /(.+\/)(?!index|app|dashboards|drillToItem|livingStrategyDashboard|news|notifications|preformanceIndicators|strategy|swot|trendTopics)\w+\.js$/);
req.keys().forEach(function (file) {
    var mod = req(file);
    var actions = mod.default || mod;
    for (var name in actions) {
        if (exports[name]) {
            throw Error("Duplicate action: " + name);
        }
        exports[name] = actions[name] ? actions[name].default || actions[name] : actions[name];
    }
});

module.exports = exports;